import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import * as Raven from "raven-js";
import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";

Raven.config("https://b495f6fe77164a109e51e92f3cadebbc@sentry.io/1206331", {
  environment: process.env.NODE_ENV
}).install();

ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);



// WEBPACK FOOTER //
// ./src/index.tsx